import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectIsOauthAuthenticatable } from 'ducks/currentUser/selectors/base'
import {
  selectIsBootstrapped,
  selectVersion,
} from 'subapps/onboarding/selectors'

const progressSteps = {
  6: {
    emailSignup: ['V6EmailPage', 'V6VerificationPage'],
    oauthSignup: ['V6CompanyPage', 'V6CompanyPage2'],
    noBootstrappedPage: ['V6EmailPage', 'V6SignupPage'],
  },
}

const defaultProgress = 1

const getProgress = (page, oauthAuthenticatable, v) => {
  const signup =
    oauthAuthenticatable === true
      ? progressSteps[v]?.oauthSignup
      : progressSteps[v]?.emailSignup
  const progressStep = signup.indexOf(page)
  if (progressStep !== -1) {
    return (100 * (progressStep + 1) / (signup.length + 1)).toFixed(5)
  }
  return defaultProgress
}

const isNoBootstrappedPage = (currentPage, v) =>
  progressSteps[v]?.noBootstrappedPage?.some(page => currentPage === page)

export const useProgress = page => {
  const isBootstrapped = useSelector(selectIsBootstrapped)
  const oauthAuthenticatable = useSelector(selectIsOauthAuthenticatable)
  const version = useSelector(selectVersion)
  const [progress, setProgress] = useState(defaultProgress)

  const loaded = isBootstrapped || isNoBootstrappedPage(page, version)

  useEffect(
    () => {
      if (loaded) {
        setProgress(getProgress(page, oauthAuthenticatable, version))
      }
    },
    [oauthAuthenticatable, page, loaded, version]
  )

  return [loaded, progress]
}
